import { render } from "./HomeInput.vue?vue&type=template&id=afb103c0&scoped=true&bindings={\"linkResult\":\"data\",\"invalid\":\"data\",\"url\":\"data\",\"isLoading\":\"data\",\"onSubmit\":\"options\",\"copyUrl\":\"options\"}"
import script from "./HomeInput.vue?vue&type=script&lang=js"
export * from "./HomeInput.vue?vue&type=script&lang=js"

import "./HomeInput.vue?vue&type=style&index=0&id=afb103c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-afb103c0"

export default script